import React from "react";
import Sidebar from "../../components/commons/Sidebar";
import Certificate from "../../components/admin/certificate/certificate";

const CertificateT = () => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <Sidebar />
      <div className="flex-1 overflow-x-auto">
        <Certificate />
      </div>
    </div>
  );
};

export default CertificateT;
